module.exports = __webpack_public_path__ + "img/promo_49.3c70b020.png";